import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';
import KeystrokePropsMixin from '@/entries/user/mixins/KeystrokePropsMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import { CellTagType, YMValue, 金融機関Cell } from '@/classes/service/計画/返済計画Service';

export default mixins(InputableTextMixin, KeystrokePropsMixin, 計画書Mixin).extend({
  name: 'C金融機関Cell',

  components: {
    KeystrokeInputableText,
  },

  props: {
    cell: {
      type: Object as PropType<金融機関Cell>,
      required: true,
    },
  },

  data(): {
    readonly cellTagType: typeof CellTagType;
  } {
    return {
      cellTagType: CellTagType,
    };
  },

  computed: {
    value(): unknown {
      // ymInputが存在、かつ値が設定されている場合はymInputを表示
      // それ以外はfixを表示
      const value = this.cell.ymInput?.value;
      return value === undefined ? this.cell.fix : value;
    },
  },

  filters: {
    cellCss(tagType: CellTagType, rowSpan: number, isDisabled: boolean): string {
      const classes: string[] = [];
      if (isDisabled) classes.push('grey');
      if (rowSpan > 1) classes.push('white');
      if (tagType !== CellTagType.textLeft) classes.push('text-right');

      return classes.join(' ');
    },
  },

  methods: {
    onChange(v: number, oldV: unknown): void {
      if (this.cell.ymInput !== undefined) {
        this.cell.ymInput.value = v;
      }

      const ymInput: YMValue = {
        ym: this.cell.決算期ym!,
        value: v,
        oldValue: oldV as number,
      };
      this.$emit('change', ymInput);
    },
  },
});
